(() => {
  'use strict';
  const selector = '[data-lb-cart-edit]';
  const ready = () => typeof window.AvisOptionsConfig?.handle_cart_edit?.handleCartEditPopup === 'function';
  function sync() {
    document.querySelectorAll(selector).forEach(button => {
      if (!button.dataset.lbBusy) button.disabled = !ready();
    });
  }
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  }).observe(document.documentElement, {childList:true, subtree:true});
  let attempts = 0;
  const timer = setInterval(() => { sync(); if (ready() || ++attempts >= 60) clearInterval(timer); }, 500);
  document.addEventListener('click', async event => {
    const button = event.target.closest?.(selector);
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.dataset.lbBusy || !ready()) return;
    const error = button.parentElement.querySelector('[data-lb-cart-edit-error]');
    if (error) error.hidden = true;
    button.dataset.lbBusy = '1';
    button.disabled = true;
    try {
      // Aris resolves product handles through /products/:handle.js.
      // Read canonical handles without navigating away from the shopper's locale.
      const response = await fetch('/cart.js', {cache:'no-store'});
      if (!response.ok) throw new Error('cart read failed');
      const cart = await response.json();
      const item = cart.items.find(item => item.key === button.dataset.lbCartEdit);
      if (!item) throw new Error('cart item changed');
      const editor = window.AvisOptionsConfig.handle_cart_edit;
      await editor.handleCartEditPopup(item, cart, false, {target:button, preventDefault(){}});
      if (!document.querySelector('.avis-cartOptionsPopup')) throw new Error('editor unavailable');
    } catch (e) {
      if (error) error.hidden = false;
    } finally {
      delete button.dataset.lbBusy;
      button.disabled = !ready();
    }
  }, true);
  sync();
})();
